<ng-template #rail>
    <adaa-period-rail
        [steps]="railSteps()"
        [selectedId]="selectedPeriod()"
        [emphasizeYears]="boldYears()"
        [truncateStart]="truncateStart()"
        [truncateEnd]="truncateEnd()"
        (stepSelect)="periodChanged($event)"
    />
</ng-template>

<div class="row">
    <div class="col-12">
        <div class="slider-container bg-card">
            @if (showChartCycle() && !disableSlider()) {
                <div class="slider-container__header">
                    @if (isEKPI()) {
                        <ng-content select="[slot='ekpi-entity-selector']"></ng-content>
                    }

                    <div class="chart-cycle">
                        @for (cycle of chartFrequencyCycles(); track cycle.id) {
                            <button
                                type="button"
                                class="chart-cycle__option"
                                [class.is-active]="isActive(cycle.id)"
                                (click)="selectChartCycle(cycle.id)"
                            >
                                {{ cycle.label | translate }}
                            </button>
                        }
                    </div>
                </div>
            }

            @if (!isReady()) {
                <div class="w-100 d-flex justify-content-center py-2">
                    <div class="zsk__loader zsk__loader--sm"></div>
                </div>
            } @else if (railSteps().length > 0) {
                @if (isMobile) {
                    <adaa-item-slider [hasTitle]="false">
                        <div class="slider-container__scroll">
                            <ng-container *ngTemplateOutlet="rail" />
                        </div>
                    </adaa-item-slider>
                } @else {
                    <ng-container *ngTemplateOutlet="rail" />
                }
            }
        </div>
    </div>
</div>
